import { combineReducers } from '@reduxjs/toolkit';
import {
    addDevBoxHyperVAccepted,
    addDevBoxHyperVError,
    addDevBoxHyperVFailed,
    addDevBoxHyperVSuccess,
} from '../actions/add-ons/hyper-v-action-creators';
import { AddOnsStatusStore, AddOnsStore } from '../store/add-ons-store';
import { createStatusReducer } from './status-reducer';

export const addOnsReducer = combineReducers<AddOnsStore>({
    status: combineReducers<AddOnsStatusStore>({
        createDevBoxHyperVAddOn: createStatusReducer({
            inProgress: addDevBoxHyperVAccepted,
            error: addDevBoxHyperVError,
            failed: addDevBoxHyperVFailed,
            success: addDevBoxHyperVSuccess,
        }),
    }),
});
